import React from "react"
import "../style/projects.css"
import Skills from "./skills"
import { useInView } from 'react-intersection-observer';
import Footer from "./footer";
import {Link} from "react-router-dom"
import {ImagesComp,ImagesCompLeft} from "./imags";




export default function Projects (props)
{
    

 

    const { ref, inView, entry } = useInView({
        
        threshold: 0,
        triggerOnce: true,
      });
    
console.log(inView);






    return( 
        <div ref={ref}  inView={inView} id="projects" className="projects_container">

            {/*  */}
            {inView ? <div className="inVieu_container"><div className="projecs_header">
            <h3>my work</h3>
                <h3 >Projects</h3>
                </div>
            <div className="project_two_container">
        <div className="project_two_info">

        <h3 className="project_two_header">Samna Olive Press Boutique</h3>
        <h3 className="project_two_sub_info">Part of my training in school was an internship in papa digital  company and this is the project that I worked on.<br/>my part of the project was the front end and the technologies that I worked whit
                                              are WordPress Java Script CSS and PHP<br/>
            </h3>
            </div>
            <div className="project_two_img_box">
                
            <a  href="https://shamna.co.il/" target="blank" ><ImagesComp imgSrc={"images/samna.png"}/><img className="imgCell" src="images/samna.png"/> 
</a>
            </div>
            </div>

            {/*  */}
            <div className="lerningPrijects_h3"><h3>Lerning Projects</h3></div>
            {/*  */}
            <div className="project_five_container">
            
        <div className="project_five_info_box">

        <h3 className="project_five_header">Toy Shop</h3>
        <h3 className="project_five_info">this project is an example of a store I made.<br/>features: payment, order's management, stock management and employ management

there are <span className="five_skill_list_span">more features</span> planned to come in the future. stay tuned;)</h3>
         
                    
                    <div className="five_skill_list">
                    <h3 ><span className="five_skill_list_span">Front End</span></h3>
                    <h3><span className="five_skill_list_span">React</span>: Redux Raoute and Hooks</h3>
                    <h3><span className="five_skill_list_span">Back End</span></h3>
                    <h3>Mongo DB</h3>
                    <h3><span className="five_skill_list_span">Data Base</span></h3>
                    <h3>information on the data base is below in the toy Api project </h3>
                   
                    </div>  
            </div>
            <div className="project_five_img_box">
            <a target="blank" href="https://my-toy-store.netlify.app/" > <ImagesCompLeft imgSrc={"images/shop.png"}/><img className="imgCell" src="images/shop.png"/></a>
            </div>
            
            </div>

            {/*  */}
            <div className="project_tree_container">
            
        <div className="project_tree_info">

        <h3 className="project_tree_header">Toy's API</h3>
         <h3 className="project_tree_frontEnd">Front End</h3>
                    
                    <div className="skill_list">
                    
                    <h3>This API was used in the toy store project.</h3>
                    <h3><span className="skill_list_span">Back End Technologies</span></h3>
                    <h3>the data was created in Mongo Db Compass,<br/>and he was saved in Mongo Db Atlas.</h3>
                   <h3><span className="skill_list_span">Nod Js</span>: Express, Mongoose</h3>
                   <h3><span className="skill_list_span">Validation and security </span>: hapi/joi,Bcrypt and json web token</h3>
                   
                    </div>
            </div>
            <div className="project_tree_img_box">
            <Link  to="/toy_api"  ><ImagesComp imgSrc={"images/toy_api.png"}/><img className="imgCell" src="images/toy_api.png"/></Link>
            </div>
            
            </div>




            {/*  */}
            <div className="project_four_container">
            
        <div className="project_four_info_box">

        <h3 className="project_four_header">To Do List</h3>
        <h3 className="project_four_info">In this app, you can make a list of tasks you need to perform,
if a task deadline is over the task will become red.<br/>
there are <span className="four_skill_list_span">more features</span> planned to come in the future. stay tuned;)</h3>
         
                    
                    <div className="four_skill_list">
                    <h3 ><span className="four_skill_list_span">Front End</span></h3>
                    <h3><span className="four_skill_list_span">React</span>: Redux Raoute and Hooks</h3>
                    <h3><span className="four_skill_list_span">Back End</span></h3>
                    <h3>The data is saved to the clinte local Storage</h3>
                   
                    </div>
            </div>
            <div className="project_four_img_box">
            <a target="blank" href="https://my-to-do-list-2020.netlify.app/" > <img className="imgCell" src="images\toDo.png"/><ImagesCompLeft imgSrc={"images/toDo.png"}/></a>
            </div>
            
            </div></div>:""}
 
            </div>
    )
}